export default "__VITE_ASSET__BmN8$$br__"